
<template>

  <div class="container-fluid">
    <div class="panel panel-info">
    <!-- <div style= "text-align:left" class="p-3 mb-2y text-black"><b>Login:</b></div> -->
    <div  class="panel-body">
        <div class="container">
        <div class="row">
             <div class="col-lg-3 col-sm-6">
                <div class="card-box bg-orange">
                    <div class="inner ;text-align:center">
                        <h1 style="color:white; text-align: center;">
                        <h3>  </h3>
                        <p> </p>
                          <router-link
                        style="color:white;"
                        :to="{ path: '/dashboard'}"
                      ><b class="animalKatta">Farmers</b> </router-link></h1>
                    </div>
                    <div class="icon">
                        <i class="fa fa-user-plus" aria-hidden="true"></i>
                    </div>
                    <a href="#" class="card-box-footer animalKattaDesc">Animal Buyer Or Seller Login<i class="fa fa-arrow-circle-right"></i></a>
                </div>
            </div>
            <div class="col-lg-3 col-sm-6">
                <div class="card-box bg-red">
                    <div class="inner;text-align:center">
                        <h1 style="color:white; text-align: center;">
                        <h3>  </h3>
                        <p> </p>
                          <router-link
                        style="color:white;"
                        :to="{ path: '/home/transport_list'}"
                      ><b class="animalKatta">  Certificate</b> </router-link></h1>
                    </div>
                    <div class="icon">
                        <i class="fa fa-users"></i>
                    </div>
                    <a href="#" class="card-box-footer animalKattaDesc">Transport Certificate Authority Login <i class="fa fa-arrow-circle-right"></i></a>
                </div>
            </div>
            <div class="col-lg-3 col-sm-3">
                <div class="card-box bg-blue">
                    <div class="inner;text-align:center">
                        <h1 style="color:white; text-align: center;">
                        <h3>  </h3>
                       <p> </p>
                        <router-link
                        style="color:white;text-align:center;"
                        :to="{ path: '/home/Doctor_dashboard'}"
                      ><b class="animalKatta">Doctor</b></router-link></h1>
                       
                    </div>
                    <div class="icon">
                        <i class="fa fa-graduation-cap" aria-hidden="true"></i>
                    </div>
                    <a href="#" class="card-box-footer animalKattaDesc">Doctor Login <i class="fa fa-arrow-circle-right"></i></a>
                </div>
            </div>
        </div>
    </div>
      
    </div>
    </div>
  </div>
 
</template>

<script>

export default {
  
};
</script>
<style scoped>
.card-box {
    position: relative;
    color: #fff;
    padding: 20px 10px 40px;
    margin: 20px 0px;
}
.card-box:hover {
    text-decoration: none;
    color: #f1f1f1;
}
.card-box:hover .icon i {
    font-size: 100px;
    transition: 1s;
    -webkit-transition: 1s;
}
.card-box .inner {
    padding: 5px 10px 0 10px;
}
.card-box h3 {
    font-size: 27px;
    font-weight: bold;
    margin: 0 0 8px 0;
    white-space: nowrap;
    padding: 0;
    text-align: left;
}
.card-box p {
    font-size: 15px;
}
.card-box .icon {
    position: absolute;
    top: auto;
    bottom: 5px;
    right: 5px;
    z-index: 0;
    font-size: 72px;
    color: rgba(0, 0, 0, 0.15);
}
.card-box .card-box-footer {
    position: absolute;
    left: 0px;
    bottom: 0px;
    text-align: center;
    padding: 3px 0;
    color: rgba(255, 255, 255, 0.8);
    background: rgba(0, 0, 0, 0.1);
    width: 100%;
    text-decoration: none;
}
.card-box:hover .card-box-footer {
    background: rgba(0, 0, 0, 0.3);
}
.bg-blue {
    background-color: #00c0ef !important;
}
.bg-green {
    background-color: #00a65a !important;
}
.bg-orange {
    background-color: #f39c12 !important;
}
.bg-red {
    background-color: #d9534f !important;
}
</style>
